export function* safe(effect, fileName, method) {
	try {
		return yield effect
	} catch (error) {
		console.log(`%cError occurs in ${fileName}, ${method} - ${error}`, 'color:#508F4E;background-color:#ffff00');
	}
}